module.exports = __webpack_public_path__ + "fonts/PTSans-Caption.ca86cc82.woff";